export default __webpack_public_path__ + "static/media/ccpbc-logo-2.70f781ba.png";